export default {
	label: 'Security need',
	overwrite: 'Change security need manually',
	bpTitle: 'Security need from business processes',
	main: 'Main',
	standard: 'Standard',
	high: 'High',
	VEITS: 'V-EITS',
	error: {
		selectAtLeastOne: 'Select at least 1 category',
	},
	dialog: {
		title: 'Confirmation',
		body1: 'Are you certain you want to change the security need?',
		body2: 'This will change the list of methods needed to be applied depending on the type selected.',
	},
	category: 'Categories',
}
